module.exports = __webpack_public_path__ + "img/xls.8d85a76c.png";